import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { RecaptchaProvider } from "@/shared/recaptcha";

// Silently swallow benign autoplay rejections so React's dev-error overlay
// doesn't hijack the page whenever the browser blocks an auto play.
(function patchMediaPlay() {
  if (typeof HTMLMediaElement === "undefined") return;
  const _play = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function (...args) {
    const p = _play.apply(this, args);
    if (p && typeof p.then === "function") {
      p.catch((err) => {
        const msg = String(err?.message || err || "");
        if (/NotAllowedError|didn't interact|play\(\) failed/i.test(msg)) return;
        // rethrow unknown errors so real issues still surface
        throw err;
      });
    }
    return p;
  };
  window.addEventListener("unhandledrejection", (e) => {
    const msg = String(e?.reason?.message || e?.reason || "");
    if (/NotAllowedError|didn't interact|play\(\) failed|privacy settings|Because of its privacy/i.test(msg)) {
      e.preventDefault();
    }
  });
  window.addEventListener("error", (e) => {
    const msg = String(e?.message || "");
    if (/NotAllowedError|didn't interact|play\(\) failed|privacy settings|Because of its privacy/i.test(msg)) {
      e.preventDefault();
    }
  });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RecaptchaProvider>
      <App />
    </RecaptchaProvider>
  </React.StrictMode>,
);
